import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { useI18n } from "../i18n";

function diff(target) {
    const ms = target.getTime() - Date.now();
    if (ms <= 0) return null;
    const s = Math.floor(ms / 1000);
    const d = Math.floor(s / 86400);
    const h = Math.floor((s % 86400) / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    return { d, h, m, s: sec };
}

export default function Countdown({ kickoff, compact = false }) {
    const { t } = useI18n();
    const target = kickoff ? new Date(kickoff) : null;
    const [v, setV] = useState(target ? diff(target) : null);

    useEffect(() => {
        if (!target) return;
        const id = setInterval(() => setV(diff(target)), 1000);
        return () => clearInterval(id);
    }, [kickoff]); // eslint-disable-line

    if (!target) return null;
    if (!v) {
        return (
            <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest text-[#FF3B30]" data-testid="countdown-locked">
                <Clock className="h-3 w-3" /> {t("cd.locked")}
            </span>
        );
    }

    if (compact) {
        const label =
            v.d > 0 ? `${v.d}${t("cd.d")} ${v.h}${t("cd.h")}` :
            v.h > 0 ? `${v.h}${t("cd.h")} ${v.m}${t("cd.m")}` :
            `${v.m}${t("cd.m")} ${v.s}${t("cd.s")}`;
        return (
            <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest text-[var(--text-secondary)]" data-testid="countdown-compact">
                <Clock className="h-3 w-3" /> {label}
            </span>
        );
    }

    return (
        <div className="flex items-center gap-2 font-heading uppercase" data-testid="countdown">
            {[
                [t("cd.d"), v.d],
                [t("cd.h"), v.h],
                [t("cd.m"), v.m],
                [t("cd.s"), v.s],
            ].map(([lbl, val]) => (
                <div key={lbl} className="text-center">
                    <div className="text-2xl font-extrabold text-[var(--text-primary)] tabular-nums">
                        {String(val).padStart(2, "0")}
                    </div>
                    <div className="text-[9px] tracking-widest text-[var(--text-muted)]">{lbl}</div>
                </div>
            ))}
        </div>
    );
}
